import { FormErrors } from 'redux-form';
import { TeamArmyView } from '@Selectors/tool/pairing/create/view/TeamArmyView';

const validate = (
  values: CreateDraftTeamParams,
): FormErrors<CreateDraftTeamParams> => {
  const errors: FormErrors<CreateDraftTeamParams> = {};

  if (!values.size || values.size <= 0) {
    errors.size = 'tool.pairing.form.size.error';
  }

  if (!values.name || values.name === '') {
    errors.name = 'tool.pairing.form.name.error';
  }

  if (
    !values.teamArmies ||
    values.teamArmies.filter((item) => item.armyId > 0).length < values.size
  ) {
    errors.teamArmies = 'tool.pairing.form.armies.error';
  }

  return errors;
};
export default validate;

export type CreateDraftTeamParams = {
  size: number;
  name: string;
  teamArmies: Array<TeamArmyView>;
};
